document.addEventListener("DOMContentLoaded", () => {
    const colors = ["#D1D9D9", "#F0E8E0", "#DFE4ED", "#EBEBEB"];

    const blocks = document.querySelectorAll(".number-block");

    blocks.forEach((block, index) => {
        const colorIndex = index % colors.length;
        const color = colors[colorIndex];

        block.style.backgroundColor = color;
    });
});